import Meta from '../../components/common/Meta';
import RedesignPageLayout from '../../components/common/RedesignPageLayout';
import AdminRecommendedPosts from '../../components/admin/AdminRecommendedPosts';

const meta = {
    title: '推荐文章管理 - 管理页面 - 博客中心',
    keywords: '管理页面',
    description: '管理页面',
};

export default function AdminRecommendedPostsPage() {
    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <header className="redesign-page-header">
                    <h1 className="redesign-page-title">推荐文章管理</h1>
                    <p className="redesign-page-desc">管理后台 — 查看并置顶推荐文章。</p>
                </header>
                <AdminRecommendedPosts />
            </RedesignPageLayout>
        </>
    );
}
